import React from "react";
import * as Style from "./styledAboutTeatcher";
import { user } from "../../.././../images";
import UseGetData from "../../../../HookAxios/getdata";
import { GET_REQUEST } from "../../../../HooksApi/useApi";
import Dots from "../../../../Components/Loader/Dots";
const AboutTeacher = ({ id }) => {
  const {
    isLoading: LoadTeacher,
    data: dataTeacher,
    isFetching: FetchingTeacher,
    isError: isErrorTeacher,
    error: errorTeacher,
    refetch: refetchTeacher,
  } = GET_REQUEST({
    queryKey: "GetTeacher",
    request: () => UseGetData("get_teacher", { id: id }),
    enabled: true,
  });

  return (
    <>
      {!LoadTeacher && dataTeacher && !FetchingTeacher ? (
        <Style.Section>
          <Style.ContentComp>
            <Style.UserComp>
              <Style.TeatcherImage>
                {dataTeacher.data.data.teacher.teacher_image === "" ? (
                  <Style.Image src={user} />
                ) : (
                  <Style.Image
                    src={`${process.env.REACT_APP_BASE_URL}${dataTeacher.data.data.teacher.teacher_image}`}
                  />
                )}
              </Style.TeatcherImage>
              <Style.TextUserComp>
                <Style.TextUser>
                  {dataTeacher.data.data.teacher.teacher_name}
                </Style.TextUser>
                <Style.TextSub>
                  <div style={{ textAlign: 'center' }}>{dataTeacher.data.data.teacher.specialization}</div>
                </Style.TextSub>
                <Style.TextSub>
                  <div style={{ width: '100%' }}
                    dangerouslySetInnerHTML={{
                      __html: dataTeacher.data.data.teacher.description,
                    }}
                  />
                </Style.TextSub>
              </Style.TextUserComp>
            </Style.UserComp>
          </Style.ContentComp>
        </Style.Section>
      ) : (
        <Dots />
      )}
    </>
  );
};

export default AboutTeacher;
